module.exports = __webpack_public_path__ + "files/08fa2e5dbb8460d9bc20f8c4362bb193.svg";